import React, { useEffect, useState } from "react";
import { Button, Layout, Space, Table, Tag, Typography, Alert, Row, Input, Col, Modal, Form, Card, Divider } from 'antd';
import { EyeOutlined, UsergroupAddOutlined, CaretLeftOutlined, CaretRightOutlined, LockOutlined, DeleteOutlined, CloseOutlined, WalletOutlined, EditOutlined } from '@ant-design/icons';
import { Link, useNavigate, useParams } from "react-router-dom";
import { inject, observer } from 'mobx-react'
import { cloneDeep } from "lodash";
import "./style.scss";
import Swal from "sweetalert2";

const { Content } = Layout;
const { Title, Text } = Typography;
const { Search } = Input;

const ZoneLeaderOrganization = ({ organizationStore, userStore }) => {

  const navigate = useNavigate()
  const [form] = Form.useForm();

  const [isEditTeamLeader, setIsEditTeamLeader] = useState(false);
  const [editableTeamLeader, setEditableTeamLeader] = useState();

  useEffect(() => {
    organizationStore.page = 1;
    organizationStore.hasMore = false;
    organizationStore.perPage = 10;
    organizationStore.fetchMembers(userStore.userID, "RECRUIT");
  }, []);

  const handlePrevPage = () => {
    organizationStore.page = organizationStore.page - 1;
    organizationStore.fetchMembers(userStore.userID, "RECRUIT");
  };

  const handleNextPage = () => {
    organizationStore.page = organizationStore.page + 1;
    organizationStore.fetchMembers(userStore.userID, "RECRUIT");
  };

  const columns = [
    {
      title: 'Name',
      key: 'FullName+ID',
      dataIndex: 'FullName',
      render: (FullName) => (
        <Text default>{FullName}</Text>
      )
    },
    {
      title: 'Precinct',
      key: 'Precint+ID',
      dataIndex: 'Precint',
      render: (Precint) => (
        <Text default>{Precint ?? "-"}</Text>
      )
    },
    {
      title: 'Street',
      key: 'Street+ID',
      dataIndex: 'Street',
      render: (Street) => (
        <Text default>{Street ?? "-"}</Text>
      )
    },
    {
      title: 'Address',
      key: 'Address+ID',
      dataIndex: 'Address',
      render: (Address) => (
        <Text default>{Address}</Text>
      )
    },
    {
      title: 'Gender',
      key: 'Sex+ID',
      dataIndex: 'Sex',
      render: (Sex) => (
        <Text default>{Sex ?? "-"}</Text>
      )
    },
  ];

  const handleUpdateTeamLeader = (values) => {

    organizationStore.updateTeamLeader(values, editableTeamLeader.UserID).then(() => {
      setIsEditTeamLeader(false);
      organizationStore.fetchMembers("RECRUIT"); // Refresh the list
    });
  };

  return (
    <div className="admin-list-team-leader">
      <Content>
        <div className="admin-content-team-leader">
          <Row justify={"space-between"} align={"middle"}>
            <Col>
              <Title level={4}>Recruits List</Title>
            </Col>
            {/* <Col>
              <Row gutter={10} align={"middle"}>
                <Col>
                  <Button 
                    type="primary" 
                    icon={<UsergroupAddOutlined /> }
                    onClick={() => navigate('add')}
                  >Add Team Leader</Button>
                </Col>
                <Col>
                  <Button 
                    type="primary" 
                    icon={<WalletOutlined /> }
                    onClick={() => navigate('top-up')}
                  >Top Up Recruits</Button>
                </Col>
              </Row>
            </Col> */}
          </Row>
          <Alert
            message="List of Recruits"
            description="List of your registered Recruits. If you think there's a problem with the list of users, please contact an administrator for assistance."
            type="info"
            showIcon
          />
          <Row justify={"end"}>
            <Button 
              type="primary" 
              icon={<UsergroupAddOutlined /> }
              onClick={() => navigate('add-invite')}
            >Add Recruit</Button>
          </Row>
          <div className="mobile-data">
            {(cloneDeep(organizationStore.members) ?? []).map((member) => (
              <Card
                className="card-data"
              >
                <Text className="name-text" strong>{member.FullName}</Text>
                <Row gutter={10} align={"middle"}>
                  <Col>
                    <Text type="secondary">Precinct: </Text>
                  </Col>
                  <Col>
                    <Tag color={"blue"}>{member.Precint}</Tag>
                  </Col>
                </Row>
                <Text type="secondary">{member.Street}</Text>
                <Text type="secondary">{member.Address}</Text>
              </Card>
              ))
            }
          </div>
          <div className="web-data">
            <Table pagination={false} columns={columns} dataSource={cloneDeep(organizationStore.members)} bordered/>
          </div>
          <ul className="pagination">
            <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={organizationStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
            <li className="pagination-item"><a>{organizationStore.page}</a></li>
            <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={organizationStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
          </ul>
        </div>
        {/* EDIT BASIC DATA FROM TEAM LEADERS MODAL */}
        <Modal 
          title="Edit details" 
          open={isEditTeamLeader} 
          onCancel={() => setIsEditTeamLeader(false)}
          footer={[
            <Button key="cancel" onClick={() => setIsEditTeamLeader(false)}>Cancel</Button>,
            <Button key="submit" type="primary" onClick={() => form.submit()}>Save Changes</Button>
          ]}
        >
          <Form
            name="editTeamLeaderData"
            layout="vertical"
            form={form} 
            onFinish={(values) => handleUpdateTeamLeader(values)}
          >
            <Form.Item label="Name" name="FullName" rules={[{ required: true, message: "Name is required" }]}>
              <Input placeholder="Enter Name" />
            </Form.Item>
            <Form.Item label="Address" name="Address" rules={[{ required: true, message: "Address is required" }]}>
              <Input placeholder="Enter Address" />
            </Form.Item>
            <Form.Item label="Contact Number" name="ContactNumber" rules={[{ required: true, message: "Contact number is required" }]}>
              <Input placeholder="Enter Contact Number" />
            </Form.Item>
            <Form.Item label="Remarks" name="Remarks" rules={[{ required: true, message: "Remarks is required" }]}>
              <Input.TextArea placeholder="Enter Remarks" />
            </Form.Item>
          </Form>
        </Modal>
      </Content>
    </div>

  );
};

export default inject('organizationStore', 'userStore')(observer(ZoneLeaderOrganization));
